import React, { useState } from 'react';
import './App.css';
import structureImg from './assets/investment-structure.png'
import processImg from './assets/investment-process.png'
import hotelImg from './assets/hotelimg.png'
import reportImg from './assets/reports.png'
import socialImg from './assets/socialImg.png'
import locationImg from './assets/locationImg.png'
import logoImg from './assets/logo.png'



function App() {
  const [activeTab, setActiveTab] = useState('Home');

  const renderContent = () => {
    switch (activeTab) {
      case 'Home':
        return <Home />;
      case 'Investment':
        return <Investment />;
      case 'Newsroom':
        return <Newsroom />;
      case 'Empowerment':
        return <Empowerment />;
      case 'About Us':
        return <AboutUs />;
      case 'Careers':
        return <Careers />;
      default:
        return <Home />;
    }
  };

  return (
    <div className="App">
      <header className="header">
      {/* App.js 내부의 header 부분 */}
        <div className="logo-container" onClick={() => setActiveTab('Home')} style={{ cursor: 'pointer'}}>
          <img src={logoImg} alt="Mega8 Logo" className="header-logo-img" />
          <div className="logo-text-group">
            <span className="logo-subtext">INVESTMENT & FINANCE</span>
            <h1 className="logo-text">Mega8 Holdings Company</h1>
          </div>
        </div>
        {/* 오른쪽 가로 메뉴 */}
        <nav className="nav-bar">
          {['Investment', 'Newsroom', 'Empowerment', 'About Us', 'Careers'].map((tab) => (
            <button 
              key={tab} 
              className={`nav-button ${activeTab === tab ? 'active' : ''}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </nav>
      </header>

      <main className="main-content">
        {renderContent()}
      </main>
    </div>
  );}
const Home = () => (
  <div className="home-section">
    <div className="hero-banner" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=2070&auto=format&fit=crop)' }}>
      <div className="hero-overlay">
        <h2 className="animate-text title">
          Sowing healthy seeds to blossom <br></br>hope here in Bangladesh
          </h2>
        <h3 className="animate-text sub-1">Accelerating Economy</h3>
        <h3 className="animate-text sub-2">Elevating Art of Living</h3>
        <h3 className="animate-text sub-3">Shaping Dream & Future</h3>
      </div>
    </div>
  </div>
);

const Investment = () => {
  // 소메뉴 상태 관리 (기본값: How We Invest)
  const [subTab, setSubTab] = useState('How We Invest');

  const renderSubContent = () => {
    switch (subTab) {
      case 'How We Invest':
        return (
          <div className="sub-content-detail" key="1">
            <h2 className="animate-text title">Investment philosophy</h2><br></br>
            <h3 className="animate-text sub1">Mega8 invests for the long term.</h3>
            <h3 className="animate-text sub1">Mega8 invests based on intrinsic value.</h3>
            <h3 className="animate-text sub1">Mega8 invests based on thorough risk assessments.</h3>
            <br></br>
            <p className="animate-text sub2">We pursue high returns through long-term investing, <br></br>
              without being shaken by short-term market volatility</p>
            <div className="animate-text investment-image-container sub3">
              <img
                src={structureImg}
                alt="Investment PPP Structure"
                className="structure-diagram"
              ></img>

            </div>
          </div>
        );
            
      case 'Investment Process':
        return (
          <div className="sub-content-detail" key="2">
            <h2 className="animate-text title">Process</h2><br></br>
            <p className="animate-text sub1">Mega8’s investment decision-making process aims to generate long-term investment
returns based on thorough research.</p>
<br></br>
            <ol className="process-list">
              <li className="animate-text sub2"><strong>Step 1. Set investment goals</strong>
              <p>Set long-term investment goals to preserve and increase the value of sovereign wealth</p>
              </li>
              <li className="animate-text sub3"><strong>Step 2. Conduct macroeconomic analysis</strong>
              <p>Carry out mid- and long-term macroeconomic research</p>
              <p>Discover and analyze new asset classes</p>
              <p>Analyze capital market expectations for each asset class</p>
              </li>
              <li className="animate-text sub4"><strong>Step 3. Implement strategic asset allocation</strong>
              <p>Analyze the risk-return profile and investment constraints for each sponsor</p>
              <p> Set optimal asset allocation rules to improve long-term returns</p>
              </li>
              <li className="animate-text sub5"><strong>Step 4. Establish investment management plans</strong>
              <p>Carry out mid- and short-term financial market analysis and forecasting</p>
              <p>Establish mid-term and annual management plans based on the economic outlook and financial market forecast</p>
              </li>
              <li className="animate-text sub6"><strong>Step 5. Execute investment strategies</strong>
              <p>Execute an asset allocation strategy based on house views decided at quarterly asset allocation forum</p>
              <p> Preemptively analyze risks according to financial market circumstances and reflect the in the overall portfolio</p>
              <p> Establish and implement investment strategies within risk limits for each asset class and fund investment</p>
              </li>
              <li className="animate-text sub7"><strong>Step 6. Monitor and analyze performance</strong>
              <p>Analyze ex-post risks and performance factors for the entire portfolio and individual investments</p>
              <p>Correct setbacks and reflect improvements based on performance and process monitoring</p>
              </li>

              {/* ... 이전 코드의 리스트 내용 동일하게 유지 ... */}
            </ol>
          </div>
        );
      case 'Sustainable Investment':
        return (
          <div className="sub-content-detail" key="3">
            <h2 className="animate-text title">Mega8's Approach to Sustainable Investment</h2>
            <br></br>
            <p className="animate-text sub1">Mega8 is committed to improving sustainability through ESGintegrated investments that take into account environmental, social and
            governance factors in the pursuit of long-term and stable returns.
            </p>
            <div className="animate-text process-image-container sub2">
              <img 
                src={processImg} 
                alt="Sustainable Investment Process" 
                className="process-diagram-img" 
              />
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="section horizontal-layout">
      {/* 왼쪽 서브 네비게이션 */}
      <aside className="sub-side-nav">
        {['How We Invest', 'Investment Process', 'Sustainable Investment'].map((item) => (
          <button
            key={item}
            className={`sub-nav-item ${subTab === item ? 'active' : ''}`}
            onClick={() => setSubTab(item)}
          >
            {item}
          </button>
        ))}
      </aside>

      {/* 오른쪽 상세 내용 */}
      <article className="sub-main-content">
        {renderSubContent()}
      </article>
    </div>
  );
};

const Newsroom = () => {
  // 소메뉴 상태 관리 (기본값: Press Release)
  const [subTab, setSubTab] = useState('Latest Stories');
  const [Announcements, setAnnouncement] = useState('Now Announcement');

  const renderSubContent = () => {
    switch (subTab) {
      case 'Latest Stories':
        return (
          <div className="sub-content-detail" key="5">
            <div className="content-flex-container">
              <div className="text-area">
                <h2 className="animate-text title">Building a premium hotel<br></br>
                at BEPZA EZ for activation of business
                </h2><br></br>
                <h3 className="animate-text sub1">
                  Promoting the buyers and clients<br></br>
                      to accomplish their business goals<br></br>
                          in the same spot at a time
                </h3><br></br><br></br>

                <div className="animate-text sub2">
                  <h3>5-Star luxury hotel</h3>
                  <div>business activities and accomodation</div>
                  <div>with world class amenity and service</div>
                </div>
                <br></br>
                <h3 className="animate-text sub3">Total Amount: U$200M</h3>
                <br></br>
                <div className="animate-text sub4">
                  <h3>Location: BEPZA EZ Mirsharai, Chattogram</h3>
                  <h3>Capacity: Stylish 360 rooms and convenient Facilities</h3>
                  <h3>Site area: 27,885m<sup>2</sup></h3>
                  <h3>Building area: 41,920<sup>2</sup></h3>
                </div>
                <br></br><br></br>
                <div className="animate-text sub5">
                  <h3>※BEPZA EZ Mirsharai, Chattogram</h3>
                  <div>
                  <div>-Zone Area: 1138.55 acre</div>
                  <div>-Plot Size: 3,600m<sup>2</sup></div>
                  <div>-Number Plots Site: 539</div>
                </div>
                </div>
              </div>

              <div className="animate-text hotel-image-area sub1">
                <img src={hotelImg} alt="Hotel project" className="side-project-img" />
              </div>
            </div>
          </div>
        );
      case 'Reports':
        return (
          
          <div className="sub-content-detail">
            <div className="reports-image-container">
              <img
                src={reportImg}
                alt="Investment PPP Structure"
                className="structure-diagram"
              ></img>

            </div>
          </div>
          
        );
      case 'Announcements':
        return (
          <div className="sub-content-detail">
            <div className="tab-status-container">
              {/* 클릭 시 hiringStatus를 변경하는 onClick 추가 */}
              <span 
                className={`tab-status ${Announcements === 'Now Announcement' ? 'active' : ''}`}
                onClick={() => setAnnouncement('Now Announcement')}
              >
                Announcement
              </span>
              <span className="tab-divider">/</span>
              <span 
                className={`tab-status ${Announcements === 'Application Closed' ? 'active' : ''}`}
                onClick={() => setAnnouncement('Application Closed')}
              >
                Notice
              </span>
            </div>

            {/* 상태에 따라 다른 메시지 출력 */}
            <div className="no-post-message">
              {Announcements === 'Now Announcement' ? (
                <p>There is no Announcements.</p>
              ) : (
                <p>There is no notice.</p>
              )}
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    // Investment에서 썼던 클래스명 'horizontal-layout'을 그대로 사용합니다.
    <div className="section horizontal-layout">
      {/* 왼쪽 서브 네비게이션 */}
      <aside className="sub-side-nav">
        {['Latest Stories', 'Reports', 'Announcements'].map((item) => (
          <button
            key={item}
            className={`sub-nav-item ${subTab === item ? 'active' : ''}`}
            onClick={() => setSubTab(item)}
          >
            {item}
          </button>
        ))}
      </aside>

      {/* 오른쪽 상세 내용 */}
      <article className="sub-main-content">
        {renderSubContent()}
      </article>
    </div>
  );
};

const Empowerment = () => {
  // 소메뉴 상태 관리
  const [subTab, setSubTab] = useState('Social Impact');

  const renderSubContent = () => {
    switch (subTab) {
      case 'Social Impact':
        return (
          <div className="sub-content-detail">
            <h2>Our commitment</h2>
            <p>Mega8 engages in social contribution activities as part of a commitment to creating a better world.</p>
            <br></br>
            <p>We carry out systematic and practical social contribution activities in the areas of emergency relief support, human resource development, future building and talent sharing. Mega8 has been assisting underprivileged children through care and self-reliance programs. In addition, the Social Contribution Committee meets every quarter to review plans for social contribution activities that are in line with Mega8’s mission, ensuring Mega8 can fulfill its social responsibility as a leading group.</p>
            <div className="sub-content-detail">
            <div className="investment-image-container">
              <img
                src={socialImg}
                alt="Investment PPP Structure"
                className="structure-diagram"
              ></img>

            </div>
          </div>
          </div>
        );
      case 'Ethical Management':
        return (
          <div className="sub-content-detail">
            <h2>Human Rights Management</h2>
            <p>Mega8 has adopted and implemented the Human Rights Management Declaration, which states, "By contributing to enhancement of people’s well-being and vitality,  as well as the growth of the domestic industry, we fulfill our responsibilities and obligations for the development of the national economy, actively practice human rights management that values human dignity and values in all management activities, and strive for social value and sustainable development in Bangladesh."</p>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="section horizontal-layout">
      {/* 왼쪽 서브 네비게이션 */}
      <aside className="sub-side-nav">
        {['Social Impact', 'Ethical Management'].map((item) => (
          <button
            key={item}
            className={`sub-nav-item ${subTab === item ? 'active' : ''}`}
            onClick={() => setSubTab(item)}
          >
            {item}
          </button>
        ))}
      </aside>

      {/* 오른쪽 상세 내용 */}
      <article className="sub-main-content">
        {renderSubContent()}
      </article>
    </div>
  );
};

const AboutUs = () => {
  const [subTab, setSubTab] = useState('CEO\'s Message');

  const renderSubContent = () => {
    switch (subTab) {
      case 'CEO\'s Message':
        return (
          <div className="sub-content-detail">
            <h2>Thank you for visiting our website.</h2><br></br>
            <p>Mega 8 Holdings is a global investment group founded on the philosophy of “Investing Human Value.” 
We go beyond conventional capital investment, striving to create meaningful value that enhances the quality of human life.
Through integrated investments across a wide range of sectors—including social infrastructure (SOC), energy and environment, 
manufacturing, ICT, healthcare, and culture & tourism—we are committed to driving sustainable growth and shaping a better future 
of Bangladesh.</p><br></br>
            <p>
              In particular, beginning with the BEPZA Economic Zone project, we have taken a significant step into the Bangladesh market, 
where we aim to contribute to tangible economic development and meaningful job
            </p><br></br>

            <p>Mega 8 Holdings operates on a foundation of financial stability through self-funded capital, enabling us to pursue long-term, 
responsible investments without reliance on external financing. In collaboration with leading global partners, we combine world-class technologies and operational expertise to help build a new industrial ecosystem.</p>
<br></br>
            <p>We believe that true development is not merely about construction, but about fostering a future where people and society grow 
together. With this belief, we place the highest priority on human dignity and value across all our business sectors in Bangladesh, 
while continuing to invest with a strong commitment to sustainability and social responsibility.
</p>
            <br></br>
            <p>Looking ahead, Mega 8 Holdings will continue to grow alongside Bangladesh—supporting its socio-economic advancement 
while contributing to a healthier and more prosperous life for its people as a trusted global partner.</p>
            <br></br>
            <p>Thank you.</p>
          </div>
        );
      case 'About Us':
        return (
          <div className="sub-content-detail">
            <h3>About Us</h3>
            <div className="process-list">
              <br></br>
              <p>Mega8 was established to contribute to the development of economy in Bangladesh creating sustainable growth through strategic investments across domestic infrastructure, energy, healthcare, ICT, and advanced industries.</p>
              <br></br>
              <h3>Legislation</h3>
              <p>Established under the Global Investment Corporation Act, Mega8 manages assets in full compliance with relevant laws and regulations. Our organization makes decisions and takes action based on clear standards and legal grounds.</p>
              <br></br>
              <h3>Global Partnership</h3>
              <p>As Global’s sovereign wealth fund striving to be among the world’s best, Mega8 has built a broad and close-knit network with leading global financial institutions. This network serves as a key driver of Mega8’s competitiveness, enhancing access to high-quality investment information and opportunities, and strengthening its position in investment negotiations.</p>
            </div>
          </div>
        );
      case 'Governance':
        return (
          <div className="sub-content-detail">
            <h3>Organization</h3><br></br>
            <p>Mega8’s organizational structure is systematically designed to support efficient asset management and responsible investment practices.
Led by the CEO, key decision-making is carried out by the Executive Committee, the Board of Directors, and the Audit Office. Specialized departments—including investment, risk management, and compliance—collaborate closely to implement Mega8’s global investment strategies.</p>
            <br></br>
            <h3>Governance</h3><br></br>
            <p>Mega8 is committed to ethical and transparent management. We manage national assets in a stable manner through an honest and fair system and faithfully fulfill our social responsibilities for the future of Global.</p>
            <br></br>
            <h3>Steering Committee</h3><br></br>
            <p>Meet our Steering Committee that deliberates and decides on matters including investment policies, and management and operational policies.</p>


          </div>
        );

      case 'Our Offices':
        return (
          <div className="sub-content-detail">
            <h2>Our Office</h2>
            <h3>PBL Tower 11th Floor, Plot -17, Kemal Ataturk Avenue, </h3>
            <h3>Gulsan-2, Dhaka - 1212,  Bangladesh</h3><br></br>
            <h3> Tel +88 02 222284017~8    </h3>
            <h3>Fax  +88 02 22229882853</h3><br></br>
            <h3 className="location">Location</h3>
            <div className="location-image-container">
              <img
                src={locationImg}
                alt="Location"
                className="structure-diagram"
              ></img>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="section horizontal-layout">
      <aside className="sub-side-nav">
        {['CEO\'s Message', 'About Us', 'Governance', 'Our Offices'].map((item) => (
          <button
            key={item}
            className={`sub-nav-item ${subTab === item ? 'active' : ''}`}
            onClick={() => setSubTab(item)}
          >
            {item}
          </button>
        ))}
      </aside>

      <article className="sub-main-content">
        {renderSubContent()}
      </article>
    </div>
  );
};

const Careers = () => {
  const [subTab, setSubTab] = useState('Job Openings');
  const [hiringStatus, setHiringStatus] = useState('Now Hiring');

  const renderSubContent = () => {
    switch (subTab) {
      case 'Job Openings':
        return (
          <div className="sub-content-detail">
            <div className="tab-status-container">
              {/* 클릭 시 hiringStatus를 변경하는 onClick 추가 */}
              <span 
                className={`tab-status ${hiringStatus === 'Now Hiring' ? 'active' : ''}`}
                onClick={() => setHiringStatus('Now Hiring')}
              >
                Now Hiring
              </span>
              <span className="tab-divider">/</span>
              <span 
                className={`tab-status ${hiringStatus === 'Application Closed' ? 'active' : ''}`}
                onClick={() => setHiringStatus('Application Closed')}
              >
                Application Closed
              </span>
            </div>

            {/* 상태에 따라 다른 메시지 출력 */}
            <div className="no-post-message">
              {hiringStatus === 'Now Hiring' ? (
                <p>There is no post currently hiring.</p>
              ) : (
                <p>No recently closed applications.</p>
              )}
            </div>
          </div>
        );
      case 'Recruitment FAQs':
        return (
          <div className="sub-content-detail">
            <h3>Recruitment FAQs</h3>
            <div className="no-post-message">
              There is no post
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="section horizontal-layout">
      <aside className="sub-side-nav">
        {['Job Openings', 'Recruitment FAQs'].map((item) => (
          <button
            key={item}
            className={`sub-nav-item ${subTab === item ? 'active' : ''}`}
            onClick={() => setSubTab(item)}
          >
            {item}
          </button>
        ))}
      </aside>

      <article className="sub-main-content">
        {renderSubContent()}
      </article>
    </div>
  );
};

export default App;